<template>
  <div  class="text-left">
    Your Application is under evaluation. The details regarding the same will soon be updated here.
  </div>
</template>

<script>

export default {
  components: {
   
  },
  name: "EvaluationStepperContent"
};
</script>

<style>
</style>